import { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { eve, eve_page, eve_count, backend, file_upload } from '../../components/apipath';
import { switchHelper, dateHelper } from "../../modules/helpers";
import "./styles/admeve.scss";
import { ColGroup } from "../../components/ColGroup.js";


const NOTE_FIELD = 'memo';
const TOTAL_COLS = 13;

function EvaRequest() {
    const [requestList, setRequestList] = useState([]);
    const [editingRequest, setEditingRequest] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [rowsCount, setRowsCount] = useState(0);
    const [page, setPage] = useState(1);
    const buildFileUrl = (u) => {
      if (!u) return "";
      const s = String(u);
      if (/^https?:\/\//i.test(s)) return s;                 // 已是完整 URL
      const base = (backend || "").replace(/\/+$/, "");      // 去掉結尾斜線
      const path = s.startsWith("/") ? s : `/${s}`;          // 確保有起始斜線
      return `${base}${path}`;
    };

    
    const toFileName = (filePathOrUrl) => {
      if (!filePathOrUrl) return "";
      const s = String(filePathOrUrl);
      try {
        // 如果是 URL，優先用 URL 的 pathname 拿檔名
        if (/^https?:\/\//i.test(s)) {
          const u = new URL(s);
          return decodeURIComponent(u.pathname.split("/").pop() || "");
        }
      } catch (_) {}
      // 一般路徑
      return decodeURIComponent(s.split("/").pop() || "");
    };
    
    const fetchData = async (customPage = page, rows = 50) => {
        try {
          setLoading(true);
      
          const params = {
            studentName: search.name || '',
            phone: search.phone || '',
            email: search.email || '',
            startDate: search.start || '',
            endDate: search.end || '',
            page: customPage - 1,
            rows
          };
      
          const response = await axios.get(eve_page(), {
            headers: { token },
            params
          });
      
          setRequestList(response.data);
          console.log('📦 response.data:', response.data);
            console.log('📤 發送參數:', params);
        } catch (error) {
          console.error('Error fetching request list:', error);
        } finally {
          setLoading(false);
        }
      };
      
      const fetchPageData = async () => {
        try {
          const params = {
            studentName: search.name || '',
            phone: search.phone || '',
            email: search.email || '',
            startDate: search.start || '',
            endDate: search.end || ''
          };
      
          const response = await axios.get(eve_count, {
            headers: { token },
            params
          });
      
          if (response.data && response.data[0]) {
            setRowsCount(response.data[0].total || 0);
          } else {
            setRowsCount(0);
          }
      
          console.log('✅ axios 請求參數:', {
            ...params,
            page: page - 1,
            rows: 50
          });
        } catch (error) {
          console.error('Error fetching total record count:', error);
          setRowsCount(0);
        }
      };

    useEffect(() => {
        console.log("rowsCount 更新後:", rowsCount);  // 確認最新的 rowsCount 值
    }, [rowsCount]);
    useEffect(() => {
        console.log("requestList 更新後:", requestList); // 確認資料是否正確被設置
    }, [requestList]);

    useEffect(() => {
        fetchPageData();
      }, []);
      
      useEffect(() => {
        fetchData(page);
      }, [page]);
      
      const handleSearchOrClear = () => {
        setPage(1);
        fetchPageData();
        fetchData(1); 
      };
      
      const handleSearch = () => {
        handleSearchOrClear();
      };
      
      const handleClear = () => {
        setSearch({ name: '', phone: '', email: '', start: '', end: '' });
        handleSearchOrClear();
      };
    // 開始編輯
    const startEditing = (row) => {
      setEditingRequest(row);
      setUpdatedData({
        ...row,
        [NOTE_FIELD]: row[NOTE_FIELD] ?? row.memo ?? ''
      });
    };

    // const formatToMysqlDatetime = (dateInput) => {
    //     const date = new Date(dateInput);
    //     const pad = (n) => (n < 10 ? '0' + n : n);
    //     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    //            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    // };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        
        let finalValue;
        if (type === 'checkbox') {
            finalValue = switchHelper(checked);
        } else if (type === 'number') {
            finalValue = value === '' ? '' : parseInt(value, 10);
        } else if (name === "e_material") {
            finalValue = value === "true";
        } else {
            finalValue = value;
        }
    
        setUpdatedData(prevData => ({
            ...prevData,
            [name]: finalValue
        }));
    };
    
    const [search, setSearch] = useState({
        name: '',
        phone: '',
        email: '',
        start: '',
        end: ''
      });

    const getSSNLabel = (value) => {
        switch (value) {
          case 0:
          case "0":
            return "沒有";
          case 1:
          case "1":
            return "有";
        }
      };

    const getOccupationLabel = (value) => {
        switch (value) {
          case 1:
          case "1":
            return "在學生";
          case 2:
          case "2":
            return "在職者";
          case 3:
          case "3":
            return "待業中";
          case 4:
          case "4":
            return "服役中";
          default:
            return "未填寫";
        }
      };

      const getExperienceLabel = (value) => {
        switch (value) {
          case 1:
          case "1":
            return "否";
          case 2:
          case "2":
            return "1年以內";
          case 3:
          case "3":
            return "1-3年";
          case 4:
          case "4":
            return "3-5年";
          case 5:
          case "5":
            return "5年以上";
          default:
            return "未填寫";
        }
      };

      const industryMap = {
        accounting_firm: "會計事務所",
        law_firm: "法律事務所",
        banking: "銀行相關",
        financial_consulting: "金融投顧",
        manufacturing: "製造相關",
        ecommerce: "電子商務",
        biotechnology: "生物科技",
        software_engineering: "資訊工程",
        consulting_services: "顧問服務",
        other: "其他"
      };

      const getIndustryLabel = (value) => industryMap[value] || "未填寫";

      const purposeMap = {
        cpa_exam: "抵免台灣會計師考試",
        foreign_company: "進外商公司",
        career_competition: "增加職場競爭力",
        promotion: "升遷、加薪籌碼",
        practice_demand: "執業需求",
        study_abroad: "計劃一年內出國留學",
        immigration: "計畫移民",
      };
      
      const getPurposeLabels = (purposes) => {
        if (!purposes) return [];
        const values = Array.isArray(purposes) ? purposes : purposes.split(',');
      
        return values.map((value) => {
          if (value.startsWith("other:")) {
            return `其他：${value.slice(6)}`;
          }
          return purposeMap[value] || "未知目的";
        }).join("、"); // 用頓號分隔顯示
      };

    // 更新申請記錄
    const saveChanges = async () => {
      try {
        const payload = {
          eva_id: updatedData.eva_id,
          status: updatedData.status || '審核中',
          [NOTE_FIELD]: (updatedData[NOTE_FIELD] ?? '').trim(),
        };

        console.log('✅ 更新送出的資料:', payload);

        const res = await axios.put(`${eve}`, payload, {
          headers: { Authorization: `Bearer ${token}`, token }
        });

        // 後端如果回傳整筆就用它；如果只回傳變更，就合併
        const server = (res?.data && typeof res.data === 'object') ? res.data : {};
        setRequestList(prev =>
          prev.map(r => (r.eva_id === updatedData.eva_id ? { ...r, ...server, ...payload } : r))
        );

        setEditingRequest(null); // 關閉編輯列
      } catch (err) {
        console.error('更新失敗:', err);
      }
    };

    
    const colWeights = [1,1,1,1,2,2,1,1,1,1,1,1];
    
    return (
        <>
            <div className="mt100 container-fluid p-5">
                {loading ? (
                    <p>載入中...</p>
                ) : (
                    <div className="mt-2">
                        <div className="mb-3">
                            <div className="row g-2 align-items-end">
                                <div className="col-md-2">
                                <input type="text" className="form-control" placeholder="學生姓名"
                                    value={search.name} onChange={e => setSearch(prev => ({ ...prev, name: e.target.value }))} />
                                </div>
                                {/* <div className="col-md-2">
                                <input type="text" className="form-control" placeholder="電話"
                                    value={search.phone} onChange={e => setSearch(prev => ({ ...prev, phone: e.target.value }))} />
                                </div>
                                <div className="col-md-3">
                                <input type="text" className="form-control" placeholder="信箱"
                                    value={search.email} onChange={e => setSearch(prev => ({ ...prev, email: e.target.value }))} />
                                </div> */}
                                <div className="col-md-2">
                                <label className="form-label">起始日期</label>
                                <input type="date" className="form-control"
                                    value={search.start} onChange={e => setSearch(prev => ({ ...prev, start: e.target.value }))} />
                                </div>
                                <div className="col-md-2">
                                <label className="form-label">結束日期</label>
                                <input type="date" className="form-control"
                                    value={search.end} onChange={e => setSearch(prev => ({ ...prev, end: e.target.value }))} />
                                </div>
                                <div className="align-self-end col-1">
                                  <button className="btn btn-primary me-2" onClick={handleSearch}>搜尋</button>
                                  <button className="btn btn-outline-secondary" onClick={handleClear}>清除</button>
                                </div>
                                
                            </div>
                        </div>
                        <table className="table table-striped border table-fixed w-100">
                          <ColGroup weights={colWeights} />
                            <thead>
                                <tr>
                                    <th>學生姓名</th>
                                    <th>地區</th>
                                    <th>目前身份</th>
                                    <th>職業類別</th>
                                    <th>財務工作經驗</th>
                                    <th>報考目的</th>
                                    <th>SSN</th>
                                    <th>成績單檔案</th>
                                    <th>填表日期</th>
                                    <th>評估狀態</th>
                                    <th>備註</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                            {requestList.map((request) => (
                              <Fragment key={request.eva_id}>
                                <tr>
                                    {editingRequest && editingRequest.eva_id === request.eva_id ? (
                                        <>
                                            <td colSpan={12}>
                                                <div className="container">
                                                    <div className="row g-1">
                                                        <div className="col-md-4">
                                                            <div className="input-group input-group-sm">
                                                                <span className="input-group-text">申請狀態</span>
                                                                <select
                                                                    className="form-select"
                                                                    name="status"
                                                                    value={updatedData.status}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                >
                                                                    <option value="審核中">審核中</option>
                                                                    <option value="完成">完成</option>
                                                                    <option value="取消">取消</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                              <div className="input-group input-group-sm">
                                                                <span className="input-group-text">備註</span>
                                                                <textarea
                                                                  className="form-control"
                                                                  rows={3}
                                                                  name={NOTE_FIELD}
                                                                  value={updatedData[NOTE_FIELD] ?? ''}
                                                                  onChange={handleInputChange}
                                                                  placeholder="只給管理員看的備註（不會顯示給學生）"
                                                                />
                                                              </div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={saveChanges}>
                                                    保存
                                                </button>
                                                <button className="btn btn-secondary m-1" onClick={() => setEditingRequest(null)}>
                                                    取消
                                                </button>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td> <a
                                                    href={`/adm/admmemberedit/${request.mem_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {request.student_name}
                                                </a>
                                            </td>
                                            <td>{request.area}</td>
                                            <td>{getOccupationLabel(request.occupation)}</td>
                                            <td>{getIndustryLabel(request.industry)}</td>
                                            <td>{getExperienceLabel(request.exp)}</td>
                                            <td>{getPurposeLabels(request.purpose)}</td>
                                            <td>{getSSNLabel(request.ssn)}</td>
                                            
                                            
                                            <td className="text-nowrap">
                                              {request.file || request.file_url ? (
                                                <a
                                                  className="btn btn-sm btn-outline-primary"
                                                  href={`${file_upload}member/${request.mem_id}/mTranscript`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  title="在新分頁檢視（右鍵可另存）"
                                                >
                                                  檢視文件
                                                </a>
                                              ) : (
                                                "無"
                                              )}
                                            </td>



                                            <td>{dateHelper(request.create_time, "date")}</td>
                                            <td>{request.status}</td>
                                            <td className="td-wrap" title={(request[NOTE_FIELD] ?? request.memo) || ''}>
                                              {(request[NOTE_FIELD] ?? request.memo) || '-'}
                                            </td>
                                            <td>
                                                <button className="btn btn-primary m-1" onClick={() => startEditing(request)}>
                                                    編輯
                                                </button>
                                            </td>
                                        </>
                                    )}
                                  </tr> 
                                  <tr className="table-light">
                                    <td colSpan={12} className="small text-muted">
                                      <span className="fw-bold me-2">緣由：</span>
                                      <span className="td-wrap">{request.reason || '—'}</span>
                                    </td>
                                    <td></td>
                                  </tr>
                                </Fragment>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-flex justify-content-center align-items-center my-3">
                            <button className="btn btn-outline-secondary me-2" disabled={page <= 1}
                                onClick={() => {
                                    setPage(prev => prev - 1);
                                    fetchData(page - 1);
                                }}>
                                上一頁
                            </button>
                            <span>第 {page} 頁 / 共 {Math.ceil(rowsCount / 50)} 頁</span>
                            <button className="btn btn-outline-secondary ms-2"
                                disabled={page >= Math.ceil(rowsCount / 50)}
                                onClick={() => {
                                    setPage(prev => prev + 1);
                                    fetchData(page + 1);
                                }}>
                                下一頁
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default EvaRequest;
